// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2xWPY","overflowing":"ReadFullNote_overflowing__25U4N"};